<template>
    <div class="ml-2 flex items-center">
        <div class="flex">
            <input
                type="checkbox"
                :id="item.title"
                class="peer hidden"
                :checked="item.checked"
                @click="checked(item)"
            />
            <label
                :for="item.title"
                class="select-none rounded-l border border-gray-200 py-3 px-6 transition-colors duration-200 ease-in-out cursor-pointer"
                :class="[item.checked ? 'bg-neutral-200 text-neutral-900 border-gray-200' : '']"
            >
                {{ item.title }}
            </label>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { SettingItem } from '../SettingModal.vue';

    const props = defineProps<{
        item: SettingItem;
    }>();

    const emit = defineEmits<{
        (e: 'checked', item: SettingItem): void;
    }>();

    const checked = (item: SettingItem) => {
        emit('checked', item);
    };
</script>
